import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import PageHead from "@/components/PageHead";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHead title="Sign in | ChronoVaults" noindex />
    <div className="min-h-[calc(100vh-88px)] grid lg:grid-cols-2">
      <div className="relative hidden lg:block border-r border-white/5">
        <img
          src="https://images.pexels.com/photos/2449364/pexels-photo-2449364.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Wave"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-vault-950 via-vault-950/70 to-transparent" />
        <div className="relative z-10 h-full flex items-end p-14">
          <div>
            <p className="label-mono text-terracotta">Welcome home</p>
            <p className="font-serif text-5xl text-bone mt-4 leading-tight max-w-md">
              Your vault<br />is waiting.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <p className="label-mono text-terracotta">Access</p>
          <h1 className="font-serif text-4xl text-bone mt-4 mb-10">Sign in</h1>

          <div className="space-y-5">
            <div>
              <Label className="label-mono mb-3 block">Email</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="h-12"
              />
            </div>
            <div>
              <Label className="label-mono mb-3 block">Password</Label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="h-12"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="mt-8 w-full h-12 bg-terracotta hover:bg-terracotta/90 text-white rounded-sm tracking-wide"
          >
            {loading ? "Unlocking..." : "Enter vault"}
          </Button>

          <p className="mt-6 text-sm text-white/50">
            No account yet?{" "}
            <Link to="/register" className="text-terracotta hover:underline" data-testid="link-register">
              Begin sealing
            </Link>
          </p>
        </form>
      </div>
    </div>
    </>
  );
}
